<template>
  <div class="page-wrapper" style="background-color: white; min-height: 100vh; display: flex; flex-direction: column;">
    <Header type="white" />
    <div class="_container" :class="{ _dark: type == 'dark', _light: type == 'light' }" style="flex: 1;">
      <div class="_insideContainer">
        <Title :title="getTitle" :tag="getHead" type="light" />
        <List v-if="!loading && firebaseProjects.length > 0" :list="getList" type="light" :animation="true" :animationDelay="true" :animationOffset="true" @click="onClick" @onClick="onClick" />
        <div v-else-if="!loading && firebaseProjects.length === 0" style="text-align: center; padding: 50px 0; color: #a9a7a7;">Henüz eklenmiş bir proje bulunmamaktadır.</div>
        <div v-else style="text-align: center; padding: 50px 0; color: #a9a7a7;">Projeler Yükleniyor...</div>
      </div>
    </div>
    <Footer />
  </div>
</template>

<script>
import Header from "@/components/common/Header.vue";
import Footer from "@/components/common/Footer.vue";
import Title from "@/components/common/Title.vue";
import List from "@/components/common/List.vue";
import { getFirestore, collection, getDocs } from "firebase/firestore";
import { initializeApp, getApps, getApp } from "firebase/app";

const firebaseConfig = {
  apiKey: "AIzaSyBxpNV_8UazGQ3pMReWWIdROn7AZlMT17Y",
  authDomain: "baumind-45d99.firebaseapp.com",
  projectId: "baumind-45d99",
  storageBucket: "baumind-45d99.firebasestorage.app",
  messagingSenderId: "982282716223",
  appId: "1:982282716223:web:25ebcf827c8e87c555248a",
  measurementId: "G-FDZLC80DZ2"
};

const app = !getApps().length ? initializeApp(firebaseConfig) : getApp();
const db = getFirestore(app);

export default {
  props: {
    head: { type: String, default: "Head" },
    title: { type: String, default: "Title" },
    type: { type: String, default: "light" },
  },
  components: { Header, Footer, Title, List },
  data() { return { firebaseProjects: [], loading: true }; },
  async mounted() {
    try {
      const querySnapshot = await getDocs(collection(db, "projeler"));
      let projects = [];
      querySnapshot.forEach((docSnap) => {
        const data = docSnap.data();
        projects.push({
          id: docSnap.id,
          title: data.title || 'İsimsiz Proje',
          // DİNAMİK ETİKET OKUYUCU:
          tag: data.tags && data.tags.length > 0 ? data.tags : ['PROJE', 'İNOVASYON'], 
          order: data.order !== undefined ? data.order : 9999
        });
      });
      projects.sort((a, b) => a.order - b.order);
      this.firebaseProjects = projects;
    } catch (error) { console.error("Hata:", error); } finally { this.loading = false; }
  },
  methods: {
    onClick(payload) {
      const targetLink = typeof payload === 'string' ? payload : payload.link;
      if (!targetLink) return;
      return this.$router.push("/" + this.$i18n.locale + "/" + (targetLink.startsWith('/') ? targetLink.substring(1) : targetLink).toLowerCase());
    }
  },
  computed: {
    getHead() { return this.$t("projects.tag"); },
    getTitle() { return this.$t("projects.title"); },
    getList() {
      return this.firebaseProjects.map((project) => {
        return { title: project.title, tag: project.tag, link: "projects/" + project.id, buttonText: this.$t("projects.buttonText") };
      });
    },
  },
};
</script>

<style scoped>
._container { width: 100%; display: flex; justify-content: center; align-items: center; padding-left: 5%; padding-right: 5%; padding-top: 50px; }
._insideContainer { width: 100%; max-width: 1900px; }
._dark { background-color: #141618; }
._light { background-color: white; }
</style>